import { createFileRoute } from '@tanstack/react-router';
import { RequireRole } from '../components/RequireRole';
import { PartnersList } from '../features/partners/PartnersList';

export const Route = createFileRoute('/partners/')({
  component: () => (
    // Le RP d'un réseau agrégateur gère les réseaux qu'il agrège. Un RP
    // ordinaire n'a aucun lien vers cet écran et n'y verrait de toute façon
    // que son propre réseau — `/partners` est borné par la visibilité API.
    <RequireRole allow={['admin', 'responsable_partenaire']}>
      <PartnersList />
    </RequireRole>
  ),
});
